import { useEffect, useState } from 'react';
import { RaceStatus } from '../../generated/graphql';
import type { NTJRace } from '../../hooks/useAppState';
import { useRace } from '../../hooks/useRace';
import RaceHeader from './RaceHeader/RaceHeader';
import styles from '../Race/Race.module.css';
import RaceGrid from './RaceGrid/RaceGrid';
import RaceFooter from './RaceFooter/RaceFooter';
import RaceResults from './RaceResults/RaceResults';
import type { useMeetingReturnType } from '../../hooks/useMeeting';

type Props = {
  nextToJump: NTJRace[];
  calculateNextToJump: () => void;
  meeting: useMeetingReturnType;
  isMultiMeeting: boolean;
};

export default function Race({
  nextToJump,
  calculateNextToJump,
  meeting,
  isMultiMeeting,
}: Props) {
  const [currentRace, setCurrentRace] = useState<NTJRace>();

  useEffect(() => {
    if (nextToJump && nextToJump.length) {
      setCurrentRace(nextToJump[0]);
    }
  }, [nextToJump]);

  const race = useRace(currentRace?.id).race;

  useEffect(() => {
    if (
      race &&
      ((!isMultiMeeting && race.status === RaceStatus.Final) ||
        (isMultiMeeting && race.status !== RaceStatus.Open))
    ) {
      calculateNextToJump();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nextToJump, race]);

  //TODO add loading component
  if (!race) return null;

  return (
    <div className={styles.raceContainer}>
      <div className={styles.header}>
        <RaceHeader race={race} />
      </div>
      <div className={styles.raceGrid}>
        {race.results.length && race.results.length > 0 ? (
          <RaceResults race={race} />
        ) : (
          <RaceGrid race={race} />
        )}
      </div>
      <div className={styles.footer}>
        <RaceFooter race={race} meeting={meeting} />
      </div>
      {/* Previous Race Details 1st 2nd 3rd Result + Current Market % + Win and Place pools + Scratchings */}
    </div>
  );
}
